// @flow
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FocusedImage from 'Components/FocusedImage';
import AssetModel from 'Stores/AssetModel';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import { withRouter } from 'react-router-dom';
import { Watch } from 'scrollmonitor-react';

const cx = classNames.bind(styles);

const MoodImage = ({ deeplinkId, image, isInViewport, stopWatcher }) => {
  const imageAsset = new AssetModel(image);

  const className = cx('mood-image', {
    inView: window.isPreview || isInViewport,
  });

  useEffect(() => {
    if (isInViewport) {
      stopWatcher();
    }
  }, [isInViewport, stopWatcher]);

  return (
    <div className={className} id={deeplinkId}>
      <FocusedImage
        image={imageAsset}
        useThumb={imageAsset && imageAsset.shouldUseThumb()}
        imageMobile={false}
      />
    </div>
  );
};

MoodImage.propTypes = {
  deeplinkId: PropTypes.number,
  image: PropTypes.instanceOf(AssetModel),
};

export default withRouter(Watch(MoodImage));
